<template>
  <header class="bg-red-claro flex flex-row h-auto pb-3 pt-3 p-4 sm:p-6 ">
    <router-link to="/">
      <img
        importance="high"
        src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro-controle.svg"
        alt="Claro Controle"
      />
    </router-link>

  </header>
</template>

<script>
export default {
  name: 'app-header'
}
</script>
